// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__0ghbd","MuiModal-backdrop":"style_MuiModal-backdrop__p6Fji","pinContainer":"style_pinContainer__YRle7","companyContainer":"style_companyContainer__JGMBj"};